var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.81,
    height: 32.9,
    viewBox: "0 0 30.81 32.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#369e3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.627 28.139H1.25V7.074c0-1.636.487-3.131 1.371-4.21.604-.736 1.675-1.614 3.352-1.614h11.471c2.858 0 5.183 2.612 5.183 5.824v21.065z",
    transform: "translate(1.25) translate(2.21)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#369e3b",
    d: "M5.973 2.5C3.693 2.5 2.5 4.8 2.5 7.074v19.815h18.877V7.074c0-2.522-1.764-4.574-3.933-4.574H5.974m0-2.5h11.47c3.553 0 6.433 3.167 6.433 7.074v22.315H0V7.074C0 3.167 2.42 0 5.973 0z",
    transform: "translate(1.25) translate(2.21)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#369e3b",
    strokeLinejoin: "round",
    strokeWidth: "2.5px",
    d: "M828.731 392.82v14.419h28.31V392.82",
    transform: "translate(1.25) translate(-828.731 -375.589)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatSelected);
export default __webpack_public_path__ + "static/media/seat-selected.88da16559517bc88a17d50bcae527425.svg";
export { ForwardRef as ReactComponent };